// removed by extract-text-webpack-plugin
module.exports = {"tagsImg":"_4rFD8VQTqERNk2IGXOBii"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/elements/Tags/TagsUsage/TagsUsage.css
// module id = 1176
// module chunks = 0